<div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>